import { render } from "./QuizFilters.vue?vue&type=template&id=4c375894&scoped=true&ts=true"
import script from "./QuizFilters.vue?vue&type=script&lang=ts"
export * from "./QuizFilters.vue?vue&type=script&lang=ts"

import "./QuizFilters.vue?vue&type=style&index=0&id=4c375894&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c375894"]])

export default __exports__